import { render } from "./GrammarCommentsComponent.vue?vue&type=template&id=eafe69a4&scoped=true"
import script from "./GrammarCommentsComponent.vue?vue&type=script&lang=js"
export * from "./GrammarCommentsComponent.vue?vue&type=script&lang=js"

import "./GrammarCommentsComponent.vue?vue&type=style&index=0&id=eafe69a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eafe69a4"]])

export default __exports__